// Cookie Helpers

const setCookie = (cName, cValue, expDays) => {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

const destroyCookie = (cName) => {
    setCookie(cName, '', -1)
}

const getCookie = (cName) => {
    const v = document.cookie.match('(^|;) ?' + cName + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

(function ($) {

    const notificationTrigger = document.getElementById('notification-trigger');
    const notificationPanel = document.getElementById('notification');
    const closeBtn = document.getElementById('close-notification');
    const hideBtn = document.getElementById('notification-hide');

    class Notification {
        // Init Selectors and focus trap
        constructor(trigger, notificationPanel, closeButton, hideButton) {
            this.trigger = trigger;
            this.notificationPanel = notificationPanel;
            this.closeBtn = closeButton;
            this.hideBtn = hideButton;

            this.focusTrap = focusTrap.createFocusTrap(notificationPanel, {
                allowOutsideClick: true
            });
        }

        /**
         * Check if notification panel is open based on 'open' class in DOM
         * @returns {boolean}
         */
        notificationIsOpen() {
            return this.notificationPanel.classList.contains('open');
        }

        openNotification() {
            $(this.notificationPanel).slideDown(250);
            this.notificationPanel.classList.add('open')
            this.trigger.setAttribute('aria-expanded', 'true');
            this.focusTrap.activate();
        }

        closeNotification(persist = false) {
            $(this.notificationPanel).slideUp(250);
            this.notificationPanel.classList.remove('open')
            this.trigger.setAttribute('aria-expanded', 'false');
            this.focusTrap.deactivate();

            if(persist) {
                setCookie('hide-notification', Date.now(), 2);
                this.hideBasedOnCookie();
            }
        }

        hideBasedOnCookie() {
            const notificationLastUpdated = this.trigger.getAttribute('data-timestamp');
            const cookieSetTimestamp = getCookie('hide-notification');

            if(notificationLastUpdated >= cookieSetTimestamp) {
                destroyCookie('hide-notification');
            }

            if(cookieSetTimestamp) {
                this.notificationPanel.classList.add('d-none');
                this.trigger.classList.add('d-none');
            }
        }

        setupClickEvents() {
            this.trigger.addEventListener('click', () => this.openNotification());
            this.closeBtn.addEventListener('click', () => this.closeNotification());
            this.hideBtn.addEventListener('click', () => this.closeNotification(true));

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.closeNotification()
                }
            })
        }

        init() {
            this.setupClickEvents();
            this.hideBasedOnCookie();
        }
    }

    if (notificationTrigger && notificationPanel && closeBtn && hideBtn) {
        new Notification(notificationTrigger, notificationPanel, closeBtn, hideBtn).init();
    }

})(jQuery);